import React from "react";
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { Card, CardContent, Grid, Typography, Avatar, Box, } from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { useGetDesignKpisQuery } from "store/slices/apis/designEngineeringDashboardSlice";
import { engineeringKpiMapper } from "./mapper";
import TitleBar from "components/TitleBar";
import AssetError from "./AssetError";

const DesignAndEngineering = ({ data, isLoading, error, assetError }) => {

    // const { projectId } = useParams();
    if (assetError) {
        return <AssetError />
    }

    if (isLoading) {
        return <Box sx={{
            background: "#fff",
            borderRadius: "8px",
            p: 4,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
            border: "1px solid #E4E4E4",
            textAlign: "center"
        }}>
            <div>Loading KPIs...</div>
        </Box>;
    }


    if (error) {

        console.error("Failed to fetch KPI metrics:", error);
        return (
            <Box sx={{
                background: "#fff",
                borderRadius: "8px",
                p: 4,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E4E4E4",
                textAlign: "center"
            }}>
                <div style={{ color: 'red' }}>
                    Error loading data: {error.status} - {error.data?.message || "Please try again."}
                </div>
            </Box>

        );
    }

    if (!data) {
        return null;
    }

    const kpis = engineeringKpiMapper(data?.data || {});


    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: "3px",
                border: "1px solid #eef0f4",
                // p: "20px 17px 20px 34px",
                //maxHeight: { xs: "auto", md: "316px" }
                height: "100%",
                boxSizing: "border-box"
            }}
        >
            <Grid container>
                <TitleBar
                    title="Design And Engineering"
                    description="Tracks design progress to ensure efficiency and on-time project completion."
                />
            </Grid>
            {/* <Typography sx={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 600,
                fontSize: '20px',
                lineHeight: '32px',
                letterSpacing: "0px",
                color: "#05004E",

            }}>
                Design And Engineering
            </Typography>
            <Typography sx={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '30px',
                letterSpacing: "0px",
                color: "#737791",
                mb: 2
            }}>
                Tracks design progress to ensure efficiency and on-time project completion.
            </Typography> */}

            <Grid container spacing={1} sx={{ p: 2 }}>
                {kpis.map((item) => (
                    <Grid size={{ md: 4 }} key={item.label}>
                        <Card
                            elevation={0}
                            sx={{
                                height: "128px",
                                position: "relative",
                                borderRadius: "3px",
                                backgroundColor: "#FFFFFF",
                                border: "1px solid #E2E8F0",
                                borderBottom: `3px solid ${item.iconBg}`,
                            }}
                        >
                            <CardContent
                                sx={{
                                    gap: 1,
                                    p: 1.25,
                                }}
                            >
                                <Avatar
                                    sx={{
                                        width: 30,
                                        height: 30,
                                        backgroundColor: item.iconBg,
                                        fontSize: 18,
                                        fontWeight: 700,
                                    }}
                                >
                                    <CiCalendar size={16} color="#FFFFFF" />
                                </Avatar>
                                <DashboardKpiStatus color={item.iconBg} />

                                <Typography
                                    sx={{
                                        fontFamily: "Poppins, sans-serif",
                                        fontWeight: 600,
                                        fontSize: "16px",
                                        lineHeight: '21px',
                                        letterSpacing: "0px",
                                        color: '#151D48',
                                        mt: 1,
                                    }}
                                >
                                    {item.value}
                                </Typography>

                                <Typography
                                    sx={{
                                        fontFamily: "Poppins, sans-serif",
                                        fontWeight: 500,
                                        fontSize: "10.5px",
                                        lineHeight: '14px',
                                        letterSpacing: "0px",
                                        color: '#425166'
                                    }}
                                >
                                    {item.label}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
};

export default DesignAndEngineering;
